import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger"
import { Flip } from "gsap/Flip"
import CustomEase from "gsap/CustomEase";
import SplitType from "split-type";
import Exp from '../../experience/Exp';
gsap.registerPlugin(Flip, ScrollTrigger, CustomEase);

export default class Home {
    namespace = 'home'
    beforeEnter = function () {
        console.log('HOME SCRIPT')
        setTimeout(() => {
            homeHeroMarquee();
        }, 10);

        scrollAnimationGrid();
        triggerProjectItem();
        triggerProjectTitle();
        triggerAboutTitle();
    }
}

function homeHeroMarquee() {
    console.log('homeHeroMarquee()')
    let direction = 1; // 1 = forward, -1 = backward scroll 

    const roll1 = roll(".marquee-wrap .marquee-txt", { duration: 26 });
    const scroll = ScrollTrigger.create({
        trigger: document.querySelector('html'),
        onUpdate(self) {
            let velo = gsap.utils.clamp(1, 2, Math.abs(window.SCROLL.velocity).toFixed(2));
            if (self.direction !== direction) {
                direction *= -1;
            };
            gsap.set([roll1], { timeScale: velo * direction, overwrite: true })
        }
    })

    function roll(targets, vars, reverse) {
        vars = vars || {};
        vars.ease || (vars.ease = "none");
        const tl = gsap.timeline({
            repeat: -1,
            onReverseComplete() {
                this.totalTime(this.rawTime() + this.duration()); // otherwise when the playhead gets back to the beginning, it'd stop. So push the playhead forward 10 iterations (it could be any number)
            }
        });
        const elements = gsap.utils.toArray(targets);
        const clones = elements.map(el => {
            let clone = el.cloneNode(true);
            el.parentNode.appendChild(clone);
            return clone;
        });
        const positionClones = () => {
            elements.forEach((el, i) => {
                gsap.set(clones[i], {
                    position: "absolute",
                    overwrite: false,
                    left: el.offsetLeft + (reverse ? -el.offsetWidth : el.offsetWidth),
                })
            })
        };
        positionClones();
        elements.forEach((el, i) => {
            tl.to([el, clones[i]], {
                xPercent: reverse ? 100 : -100,
                ...vars
            }, 0)
        });
        window.addEventListener("resize", () => {
            let time = tl.totalTime();
            tl.totalTime(0);
            positionClones();
            tl.totalTime(time)
        })
        return tl;
    }
}

function scrollAnimationGrid() {
    console.log('scrollAnimationGrid()')
    const gridItems = document.querySelectorAll('.grid-item')
    gridItems.forEach(item => {
        const image = item.querySelector('.grid-item-img');
        const yPercentRandomVal = gsap.utils.random(-100, 100);
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: item,
                start: "top bottom",
                end: "bottom top",
                scrub: true,
            }
        })

        tl.set(image, {
            transformOrigin: `50% 50%`
        })
        tl
            .from(image, {
                yPercent: 0,
                ease: 'none',
                autoAlpha: 0,
                scale: 0,
            })
            .to(image, {
                yPercent: yPercentRandomVal / 2,
                ease: 'none',
                //scale: 1,
                autoAlpha: 1,
                scale: 1,
            })
            .to(image, {
                yPercent: yPercentRandomVal,
                ease: 'none',
                autoAlpha: 0,
                scale: 0,
            })
    });
}

function triggerProjectTitle() {
    const scroll = ScrollTrigger.create({
        trigger: document.querySelector('.sc-home-proj .title-wrap'),
        start: 'top bottom-=40%',
        end: "bottom bottom-=20%",
        onEnter: () => setState(true, true),
        onLeaveBack: () => setState(false, true),
    })
    function setState(active, flip) {
        const state = Flip.getState('.sc-home-proj .title-wrap img');
        if (active) {
            document.querySelector('.sc-home-proj .title-wrap').classList.add('end-state');
        } else {
            document.querySelector('.sc-home-proj .title-wrap').classList.remove('end-state');
        }
        if (flip) {
            Flip.from(state, {
                absolute: false,
                duration: .9,
                //ease: "Power3.easeInOut",
                ease: CustomEase.create("custom", "M0,0 C0.528,0 0.569,0.319 0.616,0.552 0.69,0.92 0.876,1 1,1 "),
            })
        }
    }
}

function triggerProjectItem() {
    let experience = new Exp();
    document.querySelector('.sc-home-proj .title-wrap').classList.add('end-state');
    const projItems = document.querySelectorAll('.sc-home-proj .proj-item');
    const projItemTitles = document.querySelectorAll('.sc-home-proj .proj-item .proj-title-wrap')
    for (let x = 0; x < projItems.length; x++) {
        const real = SplitType.create(projItems[x].querySelector('.real'), { types: 'chars' });
        const clone = SplitType.create(projItems[x].querySelector('.clone'), { types: 'chars' });
        gsap.set(real.chars, { rotateX: '0deg', translateY: '0%' })
        gsap.set(clone.chars, { rotateX: '90deg', translateY: '0%' })
        projItemTitles[x].addEventListener('pointerenter', function (e) {
            gsap.to(real.chars, { rotateX: '90deg', translateY: '-10%', duration: .5, stagger: .04, ease: 'Power2.easeInOut' })
            gsap.to(clone.chars, { delay: .06, rotateX: '0deg', translateY: '0%', duration: .5, stagger: .04, ease: 'Power2.easeInOut' })
        })
        projItemTitles[x].addEventListener('pointerleave', function (e) {
            gsap.to(real.chars, { rotateX: '0deg', translateY: '0%', duration: .5, stagger: .04, ease: 'Power2.easeInOut' })
            gsap.to(clone.chars, { rotateX: '90deg', translateY: '0%', duration: .5, stagger: .04, ease: 'Power2.easeInOut' })
        })

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: projItems[x],
                start: "top-=100% bottom",
                end: "bottom bottom-=30%",
                scrub: 1,
                ease: 'linear',
            }
        })
        tl.from(projItems[x], { autoAlpha: 0, scale: 1.3, z: 100, y: 100, rotateX: '120deg' });
    }
    document.querySelector('.sc-home-proj .title-wrap').classList.remove('end-state');
}

function triggerAboutTitle() {
    const heroContent = document.querySelector('.sc-home-hero .content');
    const aboutContentItems = document.querySelectorAll('.sc-home-about .grid-content .content-item');
    let aboutTitles = []
    for (let x = 0; x < aboutContentItems.length; x++) {
        aboutTitles[x] = SplitType.create(aboutContentItems[x], { types: 'chars' })
    }
    const t1 = aboutContentItems[0];
    const t2 = aboutContentItems[1];
    const t3 = aboutContentItems[2];
    gsap.set(aboutTitles[0].chars, { autoAlpha: 0, 'filter': 'blur(10px)', '-webkit-filter': 'blur(10px)' })
    gsap.set(aboutTitles[1].chars, { autoAlpha: 0, 'filter': 'blur(10px)', '-webkit-filter': 'blur(10px)' })
    gsap.set(aboutTitles[2].chars, { autoAlpha: 0, 'filter': 'blur(10px)', '-webkit-filter': 'blur(10px)' })
    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: document.querySelector('.sc-home-about .grid-imgs'),
            start: "top top",
            end: "bottom bottom",
            scrub: 1,
        },
    })
    tl.fromTo(t1, { autoAlpha: 0, scale: 0 }, { autoAlpha: 1, scale: 1 })
        .to(aboutTitles[0].chars, { autoAlpha: 1, 'filter': 'blur(0px)', '-webkit-filter': 'blur(0px)', stagger: 0.01 }, 0)
        .from('.sc-home-about .content-item .video-wrap', { autoAlpha: 0, 'filter': 'blur(16px)', '-webkit-filter': 'blur(16px)' }, '<20%')
        .to(heroContent, { autoAlpha: 0 }, 0)
        .to(t1, { autoAlpha: 0 })
        .fromTo(t2, { autoAlpha: 0 }, { autoAlpha: 1 })
        .to(aboutTitles[1].chars, { autoAlpha: 1, 'filter': 'blur(0px)', '-webkit-filter': 'blur(0px)', stagger: 0.01 }, '<0')
        .to(t2, { autoAlpha: 0 })
        .fromTo(t3, { autoAlpha: 0 }, { autoAlpha: 1 })
        .to(aboutTitles[2].chars, { autoAlpha: 1, 'filter': 'blur(0px)', '-webkit-filter': 'blur(0px)', stagger: 0.01 }, '<0')
        .to(t3, { autoAlpha: 0, 'filter': 'blur(10px)', scale: .8 }, '>-=20%')
}